@if ({ isDesktop: listenForSmallScreen() | async, activeRoute: featureNavService.activeRoute$ | async }; as componentData) {
  <nav>
    @for (route of routes; track route; let index = $index) {
      @if (
        !(
        (route.isSubmitRoute && mode === 'edit' && componentData.isDesktop) ||
        (componentData.isDesktop && route.id === 0 && mode === 'edit') ||
        (!componentData.isDesktop && index === 0) ||
        (route.isSubmitRoute && !componentData.isDesktop)
        )
        ) {
        <button
          class="nav-item d-block w-100"
      [ngClass]="{
        'active': mode !== 'add' && route.id === componentData.activeRoute?.id,
        'modify': mode === 'edit' && !componentData.isDesktop,
      }"
          [disabled]="route.disabled"
          (click)="canNavigate(route)">
          {{ route.title }}
          @if (
            showVisited &&
            ((mode === 'add' && componentData.isDesktop) ||
            (!componentData.isDesktop && mode === 'add') ||
            (!componentData.isDesktop && mode === 'edit' && route.isSaved))
            ) {
            @if (route.visited) {
              <fa-icon icon="check" class="green" />
            }
          }
        </button>
      }
    }
  </nav>
}
